import { Link } from '@remix-run/react'
import { type ReactNode } from 'react'

export const ActivityHero = ({
	title,
	blendImageSrc,
	blendImageAlt,
	figure,
	content,
}: {
	title: ReactNode
	blendImageSrc: string
	blendImageAlt: string
	figure: ReactNode
	content: ReactNode
}) => {
	return (
		<div className="mx-auto max-w-7xl px-6 lg:px-8">
			<div className="mx-auto grid max-w-2xl grid-cols-1 items-start gap-x-8 gap-y-16 sm:gap-y-24 lg:mx-0 lg:max-w-none lg:grid-cols-2">
				<div className="lg:pr-4">
					<div className="relative overflow-hidden rounded-3xl bg-background px-6 pb-9 pt-56 shadow-2xl sm:px-12 lg:max-w-lg lg:px-8 lg:pb-8 xl:px-10 xl:pb-10">
						<img
							className="absolute inset-0 h-full w-full object-cover brightness-125 saturate-0"
							src={blendImageSrc}
							alt={blendImageAlt}
						/>
						<div className="absolute inset-0 bg-background mix-blend-multiply"></div>
						<div
							className="absolute left-1/2 top-1/2 -ml-16 -translate-x-1/2 -translate-y-1/2 transform-gpu blur-3xl"
							aria-hidden="true"
						>
							<div
								className="aspect-[1097/845] w-[68.5625rem] bg-gradient-to-tr from-background to-[#cfd0cb] opacity-40"
								style={{
									clipPath:
										'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
								}}
							></div>
						</div>
						<figure className="relative isolate">
							{/* <img
            src="https://tailwindui.com/img/logos/workcation-logo-white.svg"
            alt=""
            className="h-12 w-auto"
          /> */}
							<div className="mt-6 text-xl font-semibold leading-8 text-white">
								{figure}
							</div>
							{/* <figcaption className="mt-6 text-sm leading-6 text-gray-300">
            <strong className="font-semibold text-white">
              Judith Rogers,
            </strong>{' '}
            CEO at Workcation
          </figcaption> */}
						</figure>
					</div>
				</div>

				<div className="text-base leading-7 text-[#e4e4df] lg:max-w-lg">
					<Link
						to="/#activities"
						className="text-base font-semibold leading-7 text-[#cfd0cb]"
					>
						Company activities
					</Link>
					<h1 className="mt-2 text-3xl font-bold tracking-tight sm:text-4xl">
						{title}
					</h1>
					<div className="max-w-xl">{content}</div>
				</div>
			</div>
		</div>
	)
}
